import React from "react";
import styled from "styled-components";
import SEO from "../components/SEO";
import { APP_NAME } from "../helpers/constants";

export default function Press() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is Clumse?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "An AI-powered asset management platform for investors (1-50 assets) to automate leasing, rent collection, maintenance, and tenant communication with live portfolio yield and DSCR.",
        },
      },
      {
        "@type": "Question",
        name: "Who should use it?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Self-managing landlords and small portfolio operators who need operational simplicity and automation-driven ROI.",
        },
      },
      {
        "@type": "Question",
        name: "How do I contact media relations?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Email press@clumse.com for press inquiries and access to the press kit.",
        },
      },
    ],
  };

  return (
    <Container>
      <SEO
        title={`Press | ${APP_NAME}`}
        description={`Clumse partners with REIA of Washington. Press kit, media contact, and coverage.`}
        url={`https://www.clumse.com/press`}
        canonical={`https://www.clumse.com/press`}
        schema={faqSchema}
      />

      <Hero>
        <HeroTitle>Clumse partners with REIA of Washington…</HeroTitle>
        <HeroSubtitle>
          Official announcement and coverage to follow post-PR. Media resources
          below.
        </HeroSubtitle>
      </Hero>

      <Section>
        <SectionTitle>Press Kit</SectionTitle>
        <Grid>
          <Card>
            <CardTitle>Logos & Brand Assets</CardTitle>
            <CardDesc>
              Download high-res logos, color palette, and usage guide.
            </CardDesc>
            <CardAction href="/press/clumse-presskit.zip">
              Download ZIP
            </CardAction>
          </Card>
          <Card>
            <CardTitle>Product Screenshots</CardTitle>
            <CardDesc>Selected screenshots of key product flows.</CardDesc>
            <CardMuted>Included in the press kit.</CardMuted>
          </Card>
          <Card>
            <CardTitle>Boilerplate</CardTitle>
            <CardDesc>
              Clumse is your AI-powered Rental Command Center for independent
              landlords to automate leasing, rent collection, maintenance, and
              tenant communication.
            </CardDesc>
          </Card>
        </Grid>
      </Section>

      <Section>
        <SectionTitle>Media Contact</SectionTitle>
        <ContactBox>
          <strong>press@clumse.com</strong>
          <span>For interviews, assets, and inquiries</span>
        </ContactBox>
      </Section>

      <Section>
        <SectionTitle>Press Mentions</SectionTitle>
        <Mentions>
          <MentionCard>
            <MentionTitle>Coming soon</MentionTitle>
            <MentionMeta> - </MentionMeta>
          </MentionCard>
        </Mentions>
      </Section>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
`;

const Hero = styled.section`
  padding: 6rem 2rem 3rem;
  text-align: center;
`;

const HeroTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 0.75rem;
`;

const HeroSubtitle = styled.p`
  color: var(--color-text-light);
  margin: 0;
`;

const Section = styled.section`
  padding: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.75rem;
  margin: 0 0 1rem 0;
  text-align: center;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  max-width: 1000px;
  margin: 0 auto;
`;

const Card = styled.div`
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border-light);
  border-radius: 12px;
  padding: 1rem;
`;

const CardTitle = styled.h3`
  margin: 0 0 0.5rem 0;
`;

const CardDesc = styled.p`
  margin: 0 0 0.75rem 0;
`;

const CardMuted = styled.div`
  color: var(--color-text-muted);
`;

const CardAction = styled.a`
  display: inline-block;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--color-primary);
  border-radius: 8px;
`;

const ContactBox = styled.div`
  max-width: 600px;
  margin: 0 auto;
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border-light);
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: center;
`;

const Mentions = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1rem;
`;

const MentionCard = styled.div`
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border-light);
  border-radius: 12px;
  padding: 1rem;
`;

const MentionTitle = styled.div`
  font-weight: 600;
`;

const MentionMeta = styled.div`
  color: var(--color-text-muted);
  font-size: 0.9rem;
`;
